import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'projects/packcert-web/src/environments/environment';
import { Message, SpinnerService } from 'shared-components';
import { SessionContextService } from '../../../../context/session-context.service';
import { DashboardsService } from '../../services/dashboards.service';
import { Router } from '@angular/router';
import { AdminService } from '../../../admin/services/admin.service';

@Component({
    selector: 'app-dash-designaciones',
    templateUrl: './dash-designaciones.component.html'
})
export class DashDesignacionesComponent implements OnInit, OnDestroy {

    public toCloseSpinner = 0;

    public mensajes = new Array<Message>();
    public showError: boolean;
    public showWarning: boolean;

    public mapURL: SafeResourceUrl;

    private etiquetadorId;
    private isDashboardReady = false;
    private paramsAlreadySent = false;
    private gisParams: any = {};
    private dashboardId = 'DSG';
    private readyTimeoutId: any = null;

    constructor(
        private readonly _router: Router,
        private readonly _dashboardsService: DashboardsService,
        private readonly _spinnerService: SpinnerService,
        private readonly _sessionContext: SessionContextService,
        private readonly _translate: TranslateService,
        private readonly _sanitizer: DomSanitizer,
        private readonly _adminService: AdminService
    ) { }

    @HostListener('window:message', ['$event'])
    handleGisMessage(event: MessageEvent) {
      if (event.origin !== environment.dashboardGeneral) {
        return;
      }

      if (event.data?.type === 'dashboard-ready') {
        this.isDashboardReady = true;
        this.clearDashboardSpinner();

        if ((this._sessionContext.sessionUser.role === 'Etiquetador' && this.etiquetadorId) ||
        this._sessionContext.sessionUser.role !== 'Etiquetador') {
          this.sendGisParams();
        }
      }
    }

    ngOnInit() {
      this._spinnerService.showSpinner();
      this.toCloseSpinner += 1;
      // evitar que el spinner bloquee la interfaz si el dashboard tarda demasiado en cargar
      this.readyTimeoutId = setTimeout(() => this.clearDashboardSpinner(), 10000);

      this.mapURL = this._sanitizer.bypassSecurityTrustResourceUrl(environment.dashboardGeneral);
      this.getGisParams();

      if (this._sessionContext.sessionUser.role === 'Etiquetador') {
        const promises: Promise<any>[] = [];
        promises.push(this.getEtiquetador());
        Promise.all(promises).then(
          () => {
            if (this.isDashboardReady) {
              this.sendGisParams();
            }
          }
        ).catch(e => console.log(e));
      } else {
        if (this.isDashboardReady) {
          this.sendGisParams();
        }
      }
    }

    ngOnDestroy() {
      if (this.readyTimeoutId) {
        clearTimeout(this.readyTimeoutId);
        this.readyTimeoutId = null;
      }
      
      if (this.toCloseSpinner > 0) {
        this._spinnerService.hideSpinner();
      }
    }

    public getEtiquetador(): Promise<any> {
      return new Promise((resolve, reject) => {
        let filters = {
          userName: this._sessionContext.sessionUser.userName
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._adminService.getEtiquetadoresByEntidadControl(filters).toPromise().finally(() => {
          this.checkCloseSpinner();
        }).then((resp) => {
          if (resp) {
            this.etiquetadorId = resp.lista[0].id;
            this.gisParams.userData.etiquetadorId = this.etiquetadorId;
          }
          setTimeout(resolve, 1);
        }).catch((error) => {
          reject(error);
        });
      });
    }

    public openDocHelp() {
      this._spinnerService.showSpinner();
      this.toCloseSpinner += 1;
      this._dashboardsService.getDocHelp('Dashboards_Designations.pdf').toPromise().finally(() => {
          this.checkCloseSpinner();
      }).then((resp) => {
          localStorage.setItem('base64', resp.base64Archivo);
          const url = this._router.serializeUrl(this._router.createUrlTree(['viewPdf']));
          window.open(url, '_blank');
      });
    }

    private clearDashboardSpinner() {
      if (this.readyTimeoutId) {
        clearTimeout(this.readyTimeoutId);
        this.readyTimeoutId = null;
        this.checkCloseSpinner();
      }
    }

    private checkCloseSpinner() {
      this.toCloseSpinner -= 1;
      if (this.toCloseSpinner === 0) {
          this._spinnerService.hideSpinner();
      }
    }

    /**
     * Obtener los parámetros comunes a Etiquetador y admin
     */
    private getGisParams() {
      this.gisParams = {
        userData: {
          dashboard: this.dashboardId,
          entorno: environment.dashboardEnv,
          token: this._sessionContext.sessionUser.token,
          refreshToken: this._sessionContext.sessionUser.refreshToken.token,
          rol: this._sessionContext.sessionUser.role,
          locale: this._translate.getDefaultLang(),
        },
      };
    }

    private sendGisParams() {
    if (!this.paramsAlreadySent) {
      const iframe = document.querySelector('iframe');
      iframe?.contentWindow?.postMessage(
        {
          type: 'gis-params',
          payload: this.gisParams,
        },
        environment.dashboardGeneral
      );

      this.paramsAlreadySent = true;
    }
  }

}
